import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 46.1">
      <path d="M60 41.8l-4.7-9.3V1.7A1.8 1.8 0 0053.6 0H6.5a1.8 1.8 0 00-1.7 1.7v30.5L.1 41.5a.1.1 0 00-.1.1v2.2a2.1 2.1 0 002.1 2H58a2 2 0 002-2v-1.9zM6.6 1.7h46.9v29.8H6.6zm-.3 31.6h47.5l3.9 7.7H38.4l-.9-3.5a1.7 1.7 0 00-1.6-1.2H24.2a1.7 1.7 0 00-1.6 1.2l-.9 3.5H2.4zM36.6 41H23.5l.8-3h11.5zm21.7 3.1a.3.3 0 01-.3.3H2.1a.3.3 0 01-.3-.3v-1.4h56.5z"></path>
      <path d="M50.7 18.1a.9.9 0 00-.8.9v8.9H10.2V19a.9.9 0 00-.8-.9.9.9 0 00-.9.9v9.3a1.3 1.3 0 001.4 1.3h40.3a1.3 1.3 0 001.4-1.3V19a.9.9 0 00-.9-.9zM50.2 3.6H9.9A1.4 1.4 0 008.5 5v9.3a.9.9 0 00.9.9.9.9 0 00.8-.9V5.4h39.7v8.9a.9.9 0 00.8.9.9.9 0 00.9-.9V5a1.4 1.4 0 00-1.4-1.4z"></path>
    </svg>
  );
}

export default Icon;